import { forSellerOrgPath, pathnameWithoutLocale } from "@outschool/routes";

export const SELLER_ORG_LANDING_SKELETON = {
  heroBackground: "#f0f2ff",
  contentMaxWidth: 1152,
  heroGap: 48,
  heroArtMaxWidth: 440,
  heroTitleFontSize: "clamp(38px, 5.8vw, 64px)",
  heroBodyFontSize: "clamp(17px, 1.8vw, 19px)",
  navItemWidths: [112, 40, 52],
  titleLineWidths: ["92%", "74%"],
  bodyLineWidths: ["88%", "80%", "56%"],
  buttonWidth: 240,
  buttonHeight: 52,
} as const;

export function isSellerOrgLandingPath(pathname: string): boolean {
  const pathnameWithoutTrailingSlash =
    pathnameWithoutLocale(pathname).replace(/\/+$/, "") || "/";
  return pathnameWithoutTrailingSlash === forSellerOrgPath();
}
